type TranscriptListener = (transcript: string) => void;

const listeners = new Set<TranscriptListener>();

/**
 * Feed a transcript to every active Chinese speech capture, as if the recognizer had produced it.
 *
 * Speech recognition CANNOT be driven from an E2E run — Maestro can tap and type, but it has no way
 * to make the device hear Mandarin. Without a seam the entire spoken drill would be untestable
 * end-to-end, so this is the seam: the flow (or a unit test) pushes a transcript in and everything
 * downstream — segmentation, reading lookup, matching, the escalation ladder — runs exactly as it
 * does for real speech. Only the microphone is bypassed.
 *
 * Deliberately a plain module-level registry rather than a mock: per the repo's testing rules
 * nothing here is `jest.mock`ed, and this keeps the real code path live in tests.
 */
export function emitChineseSpeechTranscript(transcript: string): void {
  for (const listener of listeners) {
    listener(transcript);
  }
}

/** Subscribe a capture to injected transcripts. Returns its unsubscribe. */
export function subscribeToChineseSpeechTranscript(listener: TranscriptListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
